import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './assets/common.css'
import axios from '@/util/axios'
import storage from '@/util/storage'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import {getTime} from "@/util/date";
import session from '@/util/session'

// import store from './store'
const app = createApp(App)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    if (!session.get('token') && to.meta.login===1) {
        next({path: "/", replace: true})
    }
    next()
})

router.afterEach((to, from) => {

})

const goPage = function (url) {
    router.push(url);
}

const exportData = function (url, param, fileName) {
    axios({
        url: url,
        data: param,
        responseType: 'blob'
    }).then(res => {
        let blob = new Blob([res]);
        if ("download" in document.createElement("a")) {
            // 不是IE浏览器
            let url = window.URL.createObjectURL(blob);
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link); // 下载完成移除元素
            window.URL.revokeObjectURL(url); // 释放掉blob对象
        } else {
            // IE 10+
            window.navigator.msSaveBlob(blob, fileName);
        }
    })
}

const saveInfo = function (infoName) {
    return new Promise((resolve) => {
        // this.tempInfo = {}
        // for (let item in this[infoName]) {
        //   this.tempInfo[item] = this[infoName][item];
        // }
        // this.tempInfo = Object.assign({}, this[infoName])
        this.tempInfo = JSON.parse(JSON.stringify(this[infoName]));
        // this.tempInfo = structuredClone(this[infoName]);
        resolve()
    })
}
const resetInfo = function (infoName) {
    this[infoName] = JSON.parse(JSON.stringify(this.tempInfo));
}

const isMobile = function () {
    return /Android|webOS| iPhone | iPad | iPod |BlackBerry|opera mini|opera mobile|appleWebkit.*mobile|mobile/i.test(
        navigator.userAgent
    );
}

const getCommonInfo = function (options) {
    return new Promise((resolve) => {
        axios({
            url: '/base/getCommonInfo',
            data: {
                info: options
            },
            showInfo: 0
        }).then(res => {
            if (res.status === 1) {
                for (let item of options) {
                    this[item] = res[item];
                    session.set(item,res[item])
                }
                resolve()
            }
        })
    })
}

const getEditInfo = function (id, table, fields, link = []) {
    return new Promise((resolve) => {
        axios({
            url: '/base/getEditInfo',
            data: {
                id: id,
                table: table,
                field: fields,
                link: link
            },
            showInfo: 0
        }).then(res => {
            if (res.status === 1) {
                resolve(res.detail)
            }
        })
    })
}

const getArrayInfo = function (fields, res = []) {
    return new Promise((resolve) => {
        for (let item of fields) {
            if (item.array && item.array !== '') {
                res.push(item.array)
            }
        }
        if (res.length === 0) {
            resolve({
                result: [],
            })
            return;
        }
        res = Array.from(new Set(res));
        axios({
            url: '/base/getArrayInfo',
            data: {
                info: res
            },
            showInfo: 0
        }).then(async rest => {
            if (rest.status === 1) {
                let result = {};
                for (let item in rest.res) {
                    if (rest.res[item]) {
                        await storage.set(item, rest.res[item]);
                        result[item] = rest.res[item];
                    }
                }
                resolve(result)
            }
        })
    })
}

const getFields = function (table) {
    return new Promise((resolve, reject) => {
        // const fields = storage.get(table+'Fields');
        // if(fields){
        //     resolve(fields);
        //     return;
        // }
        axios({
            url: '/table/getTableFields',
            data: {
                table: table,
            },
            showInfo: 0
        }).then((res) => {
            if (res.status === 1) {
                storage.set(table + 'Fields', res.list);
                resolve(res.list)
            }
        })
    })
}

const getUploadUrl = function (url) {
    return window.host + '/' + window.app + url
}

const pic = function (url, refresh = false) {
    if (!url) return '';
    const firstCharacter = url.slice(0, 1);
    //第一个字符是‘/’表示是本地图片，否则为云存储图片
    return (firstCharacter === '/' ? (window.localHost + url) : (session.get('ossHOST') + url)) + (refresh ? '?' + new Date().getTime() : '');
}

const picList = function (arr, key = null) {
    let temp = [];
    arr.forEach(item => {
        const url = key === null ? item : item[key];
        if (url) {
            temp.push(pic(url))
        }
    })
    return temp;
}

const getQueryParams = function (key) {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get(key);
}

const hideloading = function () {
    this.loading = false
}
const showloading = function () {
    this.loading = true
}

const handleCurrentChange = function (p) {
    this.page = p;
    this.getList();
}
const handleSizeChange = function (size) {
    this.pagesize = size;
    this.page = 1;
    this.getList();
}

const debounce = function (fn, delay = 500) {
    let timer = null
    return function (...args) {
        if (timer != null) {
            clearTimeout(timer)
            timer = null
        }
        timer = setTimeout(() => {
            fn.call(this, ...args)
        }, delay);
    }
}

const getRemoteOptions = function (query, options, type = 'keyword') {
    return new Promise((resolve) => {
        if (typeof query === 'object') {
            query = query.join(',')
        }
        if (query === '') {
            resolve([])
            return;
        }
        axios({
            url: '/base/getRemoteOptions',
            data: {
                array: options,
                [type]: query
            },
            showInfo: 0
        }).then(res => {
            if (res.status === 1) {
                resolve(res.list)
            }
        })
    })
}

const getEditFields = function (table) {
    return new Promise((resolve) => {
        axios({
            url: '/base/getEditFields',
            data: {
                table: table,
            },
            showInfo: 0
        }).then(async res => {
            if (res.status === 1) {
                // this[table+'EditFields'] = res.fields;
                resolve({
                    fields: res.fields,
                    result: await getArrayInfo(res.fields)
                })
            }
        })
    })
}
const getShowFields = function (table, getInfo = false) {
    return new Promise((resolve) => {
        axios({
            url: '/base/getShowFields',
            data: {
                table: table,
            },
            showInfo: 0
        }).then(async res => {
            if (res.status === 1) {
                if (getInfo) {
                    await getArrayInfo(res.fields)
                    resolve(res.fields)
                } else {
                    resolve(res.fields)
                }
            }
        })
    })
}

const getTableFields = function (table) {
    return new Promise((resolve) => {
        axios({
            url: '/base/getTableFields',
            data: {
                table: table,
            },
            showInfo: 0
        }).then(res => {
            resolve(res)
        })
    })
}

const getInfoItem = function (fields, res = {id: ''}) {
    return new Promise(async (resolve) => {
        for (let item of fields) {
            if (Object.keys(res).includes(item.value)) {
                continue;
            }
            switch (item.type) {
                case 'diyselect':
                case 'selectnumber':
                    if (item.multiple === 1) {
                        res[item.value] = [];
                    } else {
                        res[item.value] = ["''", ''].includes(item.defaultValue) ? '' : parseInt(item.defaultValue);
                    }
                    break;
                case 'select':
                    if (item.multiple === 1) {
                        res[item.value] = [];
                    } else {
                        res[item.value] = item.defaultValue === "''" ? '' : item.defaultValue;
                    }
                    break;
                case 'cascader':
                case 'cascadernumber':
                case 'image':
                case 'file':
                    res[item.value] = [];
                    break;
                case 'daterange':
                    res[item.value] = [getTime(), getTime()];
                    res[item.value + '_text'] = '';
                    res[item.value + '_start'] = '';
                    res[item.value + '_end'] = '';
                    break;
                case 'int':
                    res[item.value] = ["''", ''].includes(item.defaultValue) ? '' : parseInt(item.defaultValue);
                    break;
                default:
                    res[item.value] = '';
            }
        }
        resolve(res)
    })
}

const exeFunc = function (func) {
    return function () {
        func()
    }
}

const getStorageData = async (options) => {
    for (let item of options) {
        this[item] = await storage.get(item);
    }
}

const baseController = (controller, params = {}) => {
    return new Promise((resolve) => {
        axios({
            url: '/base/baseController',
            data: {
                controller: controller,
                params: params
            },
            showInfo: 0
        }).then(res => {
            resolve(res)
        })
    })
}
// storage.set('targetUnitList',{
// {
//     label:'元',
// }
// })

app.config.globalProperties.tempInfo = {}
app.config.globalProperties.isMobile = isMobile()
app.config.globalProperties.HOST = window.host
app.config.globalProperties.loading = false
app.config.globalProperties.page = 1
app.config.globalProperties.total = 0
app.config.globalProperties.formLabelWidth = '120px'
app.config.globalProperties.pagesizes = ['10', '20', '50', '100', '1000']
app.config.globalProperties.pagesize = 10
app.config.globalProperties.layout = isMobile() ? 'prev, pager, next' : 'total, sizes, prev, pager, next, jumper'
app.config.globalProperties.getArray = false
app.config.globalProperties.diyArray = []
app.config.globalProperties.optionsShow = []
app.config.globalProperties.crntArray = ''
app.config.globalProperties.propList = {}
app.config.globalProperties.tableSetting = {}
app.config.globalProperties.$axios = axios
app.config.globalProperties.$setStorage = storage.set
app.config.globalProperties.$getStorage = storage.get
app.config.globalProperties.$removeStorage = storage.remove
app.config.globalProperties.$clearStorage = storage.clear
app.config.globalProperties.$setSession = session.set
app.config.globalProperties.$getSession = session.get
app.config.globalProperties.$removeSession = session.remove
app.config.globalProperties.$clearSession = session.clear
app.config.globalProperties.$goPage = goPage
app.config.globalProperties.$exportData = exportData
app.config.globalProperties.$saveInfo = saveInfo
app.config.globalProperties.$resetInfo = resetInfo
app.config.globalProperties.$getCommonInfo = getCommonInfo
app.config.globalProperties.$getUploadUrl = getUploadUrl
app.config.globalProperties.$pic = pic
app.config.globalProperties.$picList = picList
app.config.globalProperties.$hideloading = hideloading
app.config.globalProperties.$showloading = showloading
app.config.globalProperties.$handleCurrentChange = handleCurrentChange
app.config.globalProperties.$handleSizeChange = handleSizeChange
app.config.globalProperties.$debounce = debounce
app.config.globalProperties.$getFields = getFields
app.config.globalProperties.$getArrayInfo = getArrayInfo
app.config.globalProperties.$getEditInfo = getEditInfo
app.config.globalProperties.$getQueryParams = getQueryParams
app.config.globalProperties.$getRemoteOptions = getRemoteOptions
app.config.globalProperties.$getInfoItem = getInfoItem
app.config.globalProperties.$getEditFields = getEditFields
app.config.globalProperties.$exeFunc = exeFunc
app.config.globalProperties.$getShowFields = getShowFields
app.config.globalProperties.$getStorageData = getStorageData
app.config.globalProperties.$baseController = baseController
app.config.globalProperties.$getTableFields = getTableFields
app.config.globalProperties.timerangeShortcuts = [
    {
        text: '本周',
        value: [getTime('toweek', 'start'), getTime()],
    },
    {
        text: '上周',
        value: [getTime('lastweek', 'start'), getTime('lastweek')],
    },
    {
        text: '本月',
        value: [getTime('tomonth', 'start'), getTime()],
    },
    {
        text: '上月',
        value: [getTime('lastmonth', 'start'), getTime('lastmonth')],
    }
]


app.use(ElementPlus, {
    locale: zhCn,
})


app.use(router).mount('#app')
